// Per spec/blocks.md §headline (P-037.28 / D-136). One of 4 atomic Blocks
// that replace the prior `commentary` + `text-block` Blocks (dropped at
// the v9 → v10 migration). Renders a single-line headline in the system
// ≥18 px accent-navy-deep convention (D-118).
//
// **Typography matches the pre-D-136 commentary headline:** 21 px `<h2>`
// in `accent-navy-deep` (#041e42). Bold weight. Left-aligned. The atomic
// split lets staff compose "letter"-style emails freely (headline +
// `text` body + `button` CTA + `author` byline) without the commentary
// Block's hard-coded ordering or the text-block's CTA-coupling.
//
// **Outer cell padding: 30 px L/R (D-114 content-gutter convention).** No
// top padding — vertical rhythm between this Block and the next is the
// document-shell's between-block rhythm. Composing a `section-heading`
// Block above this one slots into the same rhythm as the rest of the
// system.
//
// **Auto-hide on empty `headline`.** Required field at the Zod layer
// (`min(1)`), but defense-in-depth: if persisted state slips through
// with an empty string, the Block returns `EMPTY_HTML` rather than an
// empty styled `<h2>`.

import { z } from 'zod'
import { defineBlock } from '../render/define-block'
import { html } from '../render'
import { tokens } from '../tokens'
import { heading } from '../primitives/heading'

const optionsSchema = z.object({})

const inputsSchema = z.object({
  headline: z.string().min(1),
})

const HEADLINE_SIZE_PX = 21
const HEADLINE_COLOR = tokens.color['accent-navy-deep']

export const headline = defineBlock({
  id: 'headline',
  label: 'Headline',
  category: 'content',
  optionsSchema,
  inputsSchema,
  defaultOptions: {},
  defaultInputs: { headline: 'Headline goes here' },
  autoHide: ({ inputs }) => inputs.headline.length === 0,
  render: ({ inputs }) => {
    const headlineHtml = heading({
      text: inputs.headline,
      level: 2,
      color: HEADLINE_COLOR,
      size: HEADLINE_SIZE_PX,
    })
    // prettier-ignore
    return html`<table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%"><tr><td style="padding: 0 30px;">${headlineHtml}</td></tr></table>`
  },
})
